<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <div style="display: flex; align-items: center">
        <span
          ><v-btn
            icon
            color="primary"
            to="/weserve_admin_login/-/reportdashboard/main"
            class="pa-4"
          >
            <v-icon color="black">arrow_back</v-icon></v-btn
          ></span
        >
        <span class="main-title">MAIN DASHBOARD | &nbsp;</span>
        <span class="submain-title">Packages Report</span>
      </div>
    </div>
    <div>
      <v-form v-model="valid" ref="searchForm">
        <v-card dark style="border-radius: 10px">
          <v-layout row wrap class="pa-3">
            <v-flex xs12 sm10>
              <v-layout wrap>
                <v-flex xs12 sm3 class="pl-2">
                  <v-menu
                    :disabled="
                      groupSearchedConfig.length > 0 ||
                      groupReportList.length > 0
                    "
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="-30"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <v-text-field
                      label="Start"
                      v-model="searchConfig.datetime_start"
                      slot="activator"
                      prepend-icon="event"
                      hide-details
                      readonly
                      :rules="[(v) => !!v || 'required']"
                    ></v-text-field>
                    <v-date-picker
                      color="#333"
                      v-model="searchConfig.datetime_start"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="pl-2">
                  <v-menu
                    :disabled="
                      groupSearchedConfig.length > 0 ||
                      groupReportList.length > 0
                    "
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="-30"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <v-text-field
                      label="End"
                      v-model="searchConfig.datetime_end"
                      slot="activator"
                      prepend-icon="event"
                      hide-details
                      readonly
                      :rules="[(v) => !!v || 'required']"
                    ></v-text-field>
                    <v-date-picker
                      color="#333"
                      v-model="searchConfig.datetime_end"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="pl-2">
                  <v-select
                    label="Province"
                    v-model="searchConfig.province_name"
                    item-text="province_name_th"
                    item-value="province_name_en"
                    :items="provinceList"
                    hide-details
                    @change="fetchPackagesList()"
                    :rules="[(v) => !!v || 'required']"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 class="pl-2">
                  <v-select
                    label="Packages"
                    :loading="fetchingPackage"
                    v-model="searchConfig.package_id"
                    item-text="package_name"
                    item-value="package_id"
                    :items="packagesList"
                    hide-details
                    :rules="[(v) => !!v || 'required']"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm2 class="toolbar__button">
              <div class="pt-2 text-xs-center search-btn" @click="searchList()">
                <v-progress-circular
                  indeterminate
                  color="black"
                  v-if="searching"
                ></v-progress-circular>
                <v-icon large color="black" v-else>search</v-icon>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-form>
    </div>
    <div class="py-3" style="display: flex; align-items: center">
      <div
        style="display: flex; align-items: center"
        class="py-3"
        v-if="groupSearchedConfig.length > 0 || groupReportList.length > 0"
      >
        <div class="pr-3">
          <span class="search-result__title"> From: </span>
          <span class="search-result__value">{{
            searchConfig.datetime_start
          }}</span>
        </div>
        <div class="pr-3 table-header">
          <span class="search-result__title"> To: </span>
          <span class="search-result__value">
            {{ searchConfig.datetime_end }}</span
          >
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn @click="clearTable()" flat color="error" outline
        >clear table</v-btn
      >
      <!-- <v-dialog v-model="mergeDialog" width="500">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" flat color="info" outlin
            :disabled="
          groupSearchedConfig.length <= 1 || groupReportList.length <= 1
        " 
          e>Merge Table</v-btn>
        </template>
       
        <v-card>
          <v-card-title class="headline" primary-title>
            Select table you want to merge.
          </v-card-title>
          {{ mergeIndexForm }}
          <v-card-text style="max-height: 70vh; overflow: auto">
            <div v-for="(table, index) in groupReportList" :key="index">
              <v-checkbox
                color="primary"
                hide-details
                :label="`Table # ${index}`"
                v-model="mergeIndexForm"
                :value="index.toString()"
              ></v-checkbox>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pr-3">
            <v-btn
              outline
              style="width: 50%"
              color="error"
              flat
              @click="mergeDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="success"
              flat
              outline
              style="width: 50%"
              @click="mergeTable()"
            >
              Merge
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </div>

    <div v-for="(report, index) in groupReportList" :key="index">
      <div class="mt-4 table-header" style="display: flex; align-items: center">
        <div class="pr-3">
          <span class="table-header__title"> Table # :</span
          ><span class="table-header__value">{{ index + 1 }}</span>
        </div>

        <div class="pr-3 table-header">
          <span class="table-header__title"> Province: </span>
          <span class="table-header__value">{{
            groupSearchedConfig[index].province_name
          }}</span>
        </div>
        <div class="pr-3 table-header">
          <span class="table-header__title"> Package:</span>
          <span class="table-header__value">
            {{ groupSearchedConfig[index].package_data.package_name }}</span
          >
        </div>
        <v-spacer></v-spacer>
        <download-excel
          :data="report"
          :fields="{
            No: 'no',
            'Store number': 'store_number',
            'Store name': 'store_name',
            'Numbers of Order': 'number_of_order',
            'Delivery Amount(Excluded vat': 'delivery_amount',
            'Sales Amount': 'sales_amount',
          }"
          :name="`${groupSearchedConfig[index].package_data.package_name}_${groupSearchedConfig[index].datetime_start}_to_${groupSearchedConfig[index].datetime_end}.xls`"
          style="margin-right: 50px"
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
        </download-excel>

        <download-excel
          class="pr-2"
          type="csv"
          :data="report"
          :fields="{
            No: 'no',
            'Store number': 'store_number',
            'Store name': 'store_name',
            'Numbers of Order': 'number_of_order',
            'Delivery Amount(Excluded vat': 'delivery_amount',
            'Sales Amount': 'sales_amount',
          }"
          :name="`${groupSearchedConfig[index].package_data.package_name}_${groupSearchedConfig[index].datetime_start}_to_${groupSearchedConfig[index].datetime_end}.csv`"
          style=""
        >
          <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
        </download-excel>
        <div>
          <v-btn icon @click="deleteTable(index)"
            ><v-icon color="red"> delete_outline</v-icon></v-btn
          >
        </div>
      </div>
      <report-table :items="report" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import searchDateStartToEnd from "@/components/back-office/Report/SearchBar/SearchDateStartToEnd";
import packagesReportTable from "@/components/back-office/Report/MainDashboard/PackagesReportTable.vue";
export default {
  data() {
    return {
      mergeDialog: false,
      valid: false,
      searching: false,
      groupReportList: [],
      menu1: false,
      menu2: false,
      searchConfig: {
        datetime_start: null,
        package_id: 0,
        order_status: 6,
        datetime_end: null,
        province_name: null,
      },
      groupSearchedConfig: [],
      packagesList: [],
      fetchingPackage: false,
      mergeIndexForm: [],
    };
  },
  components: {
    "report-table": packagesReportTable,
    searchDateStartToEnd,
  },
  destroyed() {
    this.$store.commit("report/resetState");
  },
  created() {},
  watch: {
    mergeDialog(newValue, oldValue) {
      if (this.mergeDialog == true) {
        this.mergeIndexForm = [];
      }
    },
  },
  computed: {
    ...mapState({
      export_reward_format: (state) => state.report.export_reward_format,
      provinceList: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      fetchReportPackages: "report/fetchReportPackages",
      fetchPackagesData: "fetchPackageBack/getPackageList",
    }),
    async mergeTable() {
      this.mergeIndexForm.sort(function (a, b) {
        return a - b;
      });

      let firstIndexTable = await this.mergeValue();

      // this.mergeIndexForm.sort(function (a, b) {
      //   return b - a;
      // });
      // for (let valIndex of this.mergeIndexForm) {
      //   if (valIndex != firstIndexTable) {

      //     // this.groupReportList.splice(valIndex, 1)
      //     // this.groupSearchedConfig.splice(valIndex, 1)
      //   }
      // }

      this.mergeDialog = false;
    },
    mergeValue() {
      let firstIndexTable = 0;

      for (let val of this.mergeIndexForm) {
        console.log(this.mergeIndexForm);
        // let index = this.mergeIndexForm.indexOf(val);
        // console.log(index);
        // if (index == 0) {
        //   firstIndexTable = val;
        // } else {
        //   for (let store2 of this.groupReportList[val]) {
        //     for (let store of this.groupReportList[firstIndexTable]) {
        //       if (store.store_name == store2.store_name) {
        //         store.delivery_amount =
        //           store.delivery_amount + store2.delivery_amount;
        //         store.number_of_order =
        //           store.number_of_order + store2.number_of_order;
        //         store.sales_amount = store.sales_amount + store2.sales_amount;
        //       }
        //     }
        //   }
        // }
        return firstIndexTable;
      }
    },
    async fetchPackagesList() {
      this.packagesList = [];
      this.searchConfig.package_id = 0;
      this.fetchingPackage = true;
      this.packagesList = await this.fetchPackagesData({
        province_name: this.searchConfig.province_name
          .replace(/\s/g, "")
          .toLowerCase(),
      });
      this.fetchingPackage = false;
    },
    deleteTable(index) {
      this.groupSearchedConfig.splice(index, 1);
      this.groupReportList.splice(index, 1);
    },
    clearTable() {
      this.groupSearchedConfig = [];
      this.groupReportList = [];
    },
    async searchList() {
      if (!this.$refs.searchForm.validate()) return;
      this.searching = true;
      let config = {
        province_name: this.searchConfig.province_name
          .replace(/ /g, "")
          .toLowerCase(),
        package_id: this.searchConfig.package_id,
        order_status: this.searchConfig.order_status,
        datetime_start: this.searchConfig.datetime_start,
        datetime_end: this.searchConfig.datetime_end,
      };
      let response = await this.fetchReportPackages(config);
      if (response !== false) {
        for (let index in response.data) {
          response.data[index].no = parseInt(index) + 1;
        }
        console.log(response.data);
        this.groupReportList.push(response.data);
        let seachedConfig = {
          province_name: config.province_name.replace(/ /g, "").toUpperCase(),
          package_data: this.packagesList.find(
            (val) => val.package_id == config.package_id
          ),
          order_status: 6,
          datetime_start: config.datetime_start,
          datetime_end: config.datetime_end,
        };
        this.groupSearchedConfig.push(seachedConfig);
      }
      this.searching = false;
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Reward report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}

.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}

.table-header .table-header__value {
  color: grey;
}
.table-header .table-header__title {
  font-weight: bold;
}

.search-result__title {
  font-size: 18px;
  font-weight: bold;
}

.search-result__value {
  font-size: 18px;
  color: grey;
}

.toolbar__button {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 442px) {
  .toolbar__button {
    margin-top: 20px;
  }
}
</style>
